var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWrActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 78,
    viewBox: "0 0 97 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    clipPath: "url(#clip0_7201_48504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6101 83.6419L24.038 84.2739L24.0476 84.2711L61.9045 52.3803L56.257 50.9957C33.4318 45.4003 27.2675 31.4021 26.9135 18.5958C48.1177 40.713 64.305 47.3653 65.0244 47.6568L66.7465 48.3556L68.12 47.0941C78.4942 37.6166 71.7057 25.85 66.0758 18.339L85.7518 9.95895L85.5822 9.37299L55.9921 15.1151L58.7593 18.5617C66.4512 28.1618 70.2768 35.4454 65.4576 41.3477C60.3749 38.8211 44.9304 30.0591 26.4979 9.46129L22.1269 4.57373L21.3688 11.0914C18.8491 32.7453 28.7807 48.2141 49.4278 55.1686L15.6101 83.6419Z",
    fill: "#6AD67D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7201_48504"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87.86,
    height: 77.09,
    fill: "white",
    transform: "translate(-5 12.4241) rotate(-16.1402)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrActive);
export default __webpack_public_path__ + "static/media/wr-active.dc928f0fa4af11612c0e8dadafe52ce4.svg";
export { ForwardRef as ReactComponent };